module.exports = __webpack_public_path__ + "static/metals01-91af60e6e08351d6f8db7e54b81f72b2.png";